require([],
    function () {
        var productNavItems = [];        
        $(document).ready(function ($) {
            $(".product-navigation-container a.product-navigation-link").each(function () {
                productNavItems.push({ "navigationElement": $(this), "id": $(this).attr("href") });
            });

            $(window).on('scroll', function () {
                var partOfElementInViewport = [];                
                if (productNavItems.length == 0) return;
                for (var i = 0; i < productNavItems.length; i++) {
                    var productNavItem = productNavItems[i];                   
                    var element = $(productNavItem.id);
                    if (element && element.length > 0) {
                        if (isTopOfElementInViewport($(element)[0])) {
                            partOfElementInViewport = [];
                            partOfElementInViewport.push(productNavItem.id);
                            break;
                        }
                        if (isAnyPartOfElementInViewport($(element)[0]))
                            partOfElementInViewport.push(productNavItem.id); 
                    }
                }

                setLinks(partOfElementInViewport);               
            });
        });

        function setLinks(partOfElementInViewport) {
            var firstElement = null;
            if (partOfElementInViewport.length > 0)
                firstElement = partOfElementInViewport[0];
            for (var i = 0; i < productNavItems.length; i++) {
                var productNavItem = productNavItems[i];
                var element = $(productNavItem.id);
                if (element && element.length > 0) {                    
                    if (firstElement != null) {
                        if (productNavItem.id == firstElement)
                            $(productNavItem.navigationElement).addClass("active");
                        else
                            $(productNavItem.navigationElement).removeClass("active");
                    }
                    else
                        $(productNavItem.navigationElement).removeClass("active");
                }
            }
        }

        function isAnyPartOfElementInViewport(el) {
            const rect = el.getBoundingClientRect();            
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);           
            const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            return (vertInView);
        }

        function isTopOfElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            const vertInView = (rect.top >= 0) && (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            return (vertInView);                        
        }
});

define("ProductNavigation/productNavigation", function(){});

